import Navigation from '../../../../components/layout/Navigation';
import Footer from '../../../../components/layout/Footer';
import Hero from '../../../../components/ui/Hero';
import Section from '../../../../components/ui/Section';
import FeatureGrid from '../../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../../components/ui/ProcessTimeline';
import CTA from '../../../../components/ui/CTA';

export default function CampaignIdentityPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Defining the <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-300">Face</span> of Your Campaigns</>}
        description="We craft distinct visual and thematic identities that ensure your marketing campaigns resonate, stick, and convert."
        bgImage="/assets/marketing-campaign-design.png"
        primaryBtn={{ text: "Launch Campaign", link: "/contact", icon: "ri-rocket-line" }}
        secondaryBtn={{ text: "Our Process", link: "#process", icon: "ri-arrow-down-line" }}
      />

      <Section>
        <FeatureGrid 
          title="The Cohesive Thread of Success"
          subtitle="Effective campaign identity creates a unique aesthetic and framework for your message."
          items={[
            { title: 'Visual Language', description: 'Unique colors and typography.', icon: 'ri-palette-line', color: 'from-pink-500 to-purple-600' },
            { title: 'Thematic Cohesion', description: 'Unified narrative flow.', icon: 'ri-book-open-line', color: 'from-purple-600 to-indigo-600' },
            { title: 'Consistent Messaging', description: 'Clear core messages.', icon: 'ri-message-3-line', color: 'from-indigo-600 to-blue-600' },
            { title: 'Adaptability', description: 'Flexible across channels.', icon: 'ri-smartphone-line', color: 'from-blue-600 to-cyan-600' },
            { title: 'Memorability', description: 'Lasting brand impact.', icon: 'ri-brain-line', color: 'from-cyan-600 to-teal-600' }
          ]}
        />
      </Section>

      <Section id="process" className="bg-gray-900">
        <ProcessTimeline 
          title="From Strategy to Signature"
          subtitle="Our process ensures your campaign identity perfectly captures your vision and achieves goals."
          steps={[
            { title: 'Objectives', description: 'Defining goals & audience.', icon: 'ri-target-line', color: 'from-pink-500 to-purple-500' },
            { title: 'Concepts', description: 'Brainstorming creative themes.', icon: 'ri-lightbulb-line', color: 'from-purple-500 to-indigo-500' },
            { title: 'Design', description: 'Creating visual language.', icon: 'ri-palette-line', color: 'from-indigo-500 to-blue-500' },
            { title: 'Assets', description: 'Developing key deliverables.', icon: 'ri-image-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Guidelines', description: 'Ensuring consistency.', icon: 'ri-book-line', color: 'from-cyan-500 to-teal-500' }
          ]}
        />
      </Section>

      <CTA 
        title="Design Your Campaign's Winning Look"
        description="Partner with Hash Adz to craft a campaign identity that commands attention and delivers results."
        primaryBtn={{ text: "Start Project", link: "/contact" }}
        secondaryBtn={{ text: "View Success Stories", link: "/work" }}
      />

      <Footer />
    </div>
  );
}